import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=56e0c37c&scoped=true"
import script from "./MainPanel.vue?vue&type=script&lang=js"
export * from "./MainPanel.vue?vue&type=script&lang=js"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=56e0c37c&prod&lang=scss"
import style1 from "./MainPanel.vue?vue&type=style&index=1&id=56e0c37c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0c37c",
  null
  
)

export default component.exports